import type { ClientConfig } from '@tarot/shared';
import { apiGet } from './api';

/**
 * 서버가 내려주는 런타임 설정 (GET /config).
 *
 * 왜 빌드에 박지 않는가: 미니앱은 번들을 바꿀 때마다 **영업일 1~2일 심사**를 다시 받는다.
 * 광고 그룹 ID를 번들에 넣어 두면 광고를 켜고 끄는 데 그 사이클이 통째로 든다.
 *
 * 첫 화면에서 미리 받지 않는다 — 지금 이 값이 필요한 곳은 광고를 트는 순간뿐이라,
 * 모든 사용자에게 요청을 하나 더 지울 이유가 없다.
 */

const EMPTY: ClientConfig = { tossAdGroupId: '', tossBannerAdGroupId: '', tossEntryLink: '' };

let cached: Promise<ClientConfig> | null = null;

/**
 * 설정을 한 번만 받아 재사용한다.
 * 실패하면 **빈 설정**으로 물러난다 — 설정을 못 받았다고 화면이 죽으면 안 된다.
 */
export function clientConfig(): Promise<ClientConfig> {
  cached ??= apiGet<ClientConfig>('/config').catch(() => EMPTY);
  return cached;
}
